// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19BpW","colBig":"styles_colBig__39NOy","colSmall":"styles_colSmall__1arnp"};